'<template>
   <div class="page_list_container">
      <div class="list_titlebox">
         <h5>直播培训</h5>
      </div>
      <div class="list_navigation max_width">
         当前位置：<router-link to="/">首页 -</router-link> <router-link to="/live">直播培训 -</router-link> <a>{{liveinfo.title}}</a>
      </div>
      <div class="live_content"  v-loading="loading">
         <div class="max_width">
              <div class="live_detail_top">
                 <div class="imgbox">
                    <img :src="liveinfo.photo" alt="">
                    <span class="status">{{liveinfo.liveStatusName}}</span>
                    <el-button class="goLive" @click="goLivepage">进入直播</el-button>
                 </div>
                 <div class="right_info">
                    <div class="info_title">
                       <h5>{{liveinfo.title}}</h5>
                       <span class="iconfont right_share">&#xe8b0; <span>分享</span></span>
                    </div>
                    <div class="right_date">
                       <div class="date_col">
                          <span>讲师：{{liveinfo.lecturer != null ?liveinfo.lecturer:'--'}}</span>
                       </div>
                       <div class="date_col">
                          <span>时间：{{liveinfo.beginTime}} - {{liveinfo.endTime}}</span>
                       </div>
                    </div>
                    <el-button type="primary" class="go_live"  @click="goLivepage">进入直播</el-button>
                 </div>
              </div>
            <div class="live_detail_content">
               <div class="live_detail_title">
                  <h5>课程介绍</h5>
                 </div>
               <div class="live_detail_html" v-html="liveinfo.content"></div>
              </div>
         </div>
      </div>


      <el-dialog class="password_dialog" title="" :visible.sync="dialogVisible" width="30%"  top="35vh">
         <h5>请输入直播密码</h5>
         <input type="text" v-model="password" placeholder="直播密码">
         <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="checkLivePassword">确 定</el-button>
         </span>
      </el-dialog>

      <el-dialog class="password_dialog" title="" align-center :visible.sync="dialogQcode" width="300px" top="35vh">
         <h5>扫码观看</h5>
         <br />
         <img v-if="liveinfo.liveQrcode" :src="liveinfo.liveQrcode" class="codeimg" alt="">
         <div v-else style="text-align: center; margin-bottom: 30px;">暂无二维码</div>
         <!-- 附件 liveinfo.fileList[{name，url}] -->
        <template v-if="liveinfo.fileList && liveinfo.fileList.length > 0">
         附件
         <div class="file_list">
            <div class="file_item" v-for="(item, index) in liveinfo.fileList" :key="index">
               <span class="file_name" :title="item.name">{{ item.name }}</span>
               <a
                 class="file_download"
                 :href="item.url"
                 target="_blank"
                 rel="noopener noreferrer"
               >下载</a>
            </div>
         </div>
        </template>
      </el-dialog>
   </div>
</template>


<script>
   export default {
      name: 'list_page',
      components: {},
      data() {
         return {
            loading:true,
            code:'',
            liveinfo: {
               fileList: []
            },

            dialogVisible: false,
            password:'',

            dialogQcode:false,
         };
      },
      filters: {

      },
      mounted() {
         this.code = this.$route.params.code
         this.getInfo();
      },
      methods: {
         getInfo() {
            var _this = this;
            _this.loading = true;
            _this.$api.liveInfo({
               code: _this.code,
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.liveinfo = res.data;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
         goLivepage(){
            if(this.liveinfo.isPassword == 'Y'){
               this.dialogVisible = true;
            }else{
               this.dialogQcode = true;
            }

         },
         checkLivePassword(){
            var _this = this;
            if(this.password != ''){
               _this.loading = true;
               _this.$api.livePassword({
                  code: _this.code,
                  password:_this.password
               }).then(res => {
                  _this.loading = false;
                  if (res.code == 200) {
                    if(res.data != 0){
                       _this.liveinfo.liveQrcode = res.data.linkQrcode;
                       _this.liveinfo.fileList = res.data.fileList;
                       _this.dialogQcode = true;
                    }else{
                       _this.password = '';
                       _this.$message.error('密码错误！');
                    }
                  } else {
                     _this.$message.error(res.msg);
                  }
               }).catch(function(error) {
                  _this.loading = false;
                  _this.$message.error(error.msg);
               });
            }else{
               this.$message.error('请填写密码！');
            }
         }
      }
   }
</script>
<style lang="less" scoped>
.file_list {
  margin-top: 10px;
  max-height: 110px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  padding: 2px;
}

.file_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  font-size: 13px;

  &:hover {
    background-color: #f5f7fa;
  }
}

.file_name {
  flex: 1;
  margin-right: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file_download {
  flex-shrink: 0;
  color: #409EFF;
  text-decoration: none;
  cursor: pointer;
}

.file_download:hover {
  text-decoration: underline;
}
</style>
